
import { defineComponent, PropType, ref } from "vue";
import { microWait } from "@/lib/shared";

export default defineComponent({
  name: "InputCustomDropdown",
  props: {
    items: { type: Object as PropType<Array<unknown>> },
    selectedValue: { type: Object },
    disabled: { type: Boolean },
  },
  setup(props, context) {
    const selectWrap = ref<HTMLElement>();
    const isShow = ref(false);
    const show = async () => {
      if (!selectWrap.value) return;
      isShow.value = true;
      await microWait();
      selectWrap.value.focus();
    };
    const hide = async (e: FocusEvent) => {
      if (!selectWrap.value) return;
      const isChildClick = selectWrap.value.contains(e.relatedTarget as Node);
      if (isChildClick) return;
      isShow.value = false;
    };

    // 選択アイテムの更新と画面のクローズ
    const clickHook = async (f: () => Promise<void>) => {
      await f();
      isShow.value = false;
    };
    return {
      selectWrap,
      isShow,
      context,
      show,
      hide,
      clickHook,
    };
  },
});
